import React from 'react';
import Eventshead from '../assets//eventshead.png';
import { motion } from 'framer-motion';
// import Bts from '../assets/bts.jpg';
// import Event2 from '../assets/event2.jpeg';
// import Event3 from '../assets/event3.jpeg';
// import Pod from '../assets/pod.png';
import UpcomingEvents from '../components/UpcomingEvents';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
};

const Events = () => {
  return (
    <>
      <section
        className='relative h-[70vh] bg-cover bg-center bg-no-repeat flex items-center justify-center rounded-xl mx-4 md:mx-20 mt-20 md:mt-32'
        style={{ backgroundImage: `url(${Eventshead})` }}
      >
        <motion.div
          initial='hidden'
          whileInView='visible'
          viewport={{ once: true, amount: 0.6 }}
          variants={fadeInUp}
          className=' p-8 rounded-xl text-white text-center max-w-2xl mx-4'
        >
          <h2 className='text-3xl md:text-7xl font-bold mb-4'>
            UPCOMING EVENTS
          </h2>
          <p className=' text-white leading-relaxed'>
            Carefully curated experiences designed to inspire growth, spark
            leadership, and ignite purpose.
          </p>
        </motion.div>
      </section>
      <UpcomingEvents />
    </>
  );
};

export default Events;
